import React, { useContext, useEffect, useState } from 'react'

import SEO from '../components/SEO'
import Photo from '../components/Photo'
import Badge from '../components/Badge'
import AddToCart from '../components/AddToCart'
import SocialLinks from '../components/SocialLinks'
import { ProductsContext } from '../context/ProductContext'


function ProductPage({ pageContext: { id } }) {
  const { formatPrice, skus } = useContext(ProductsContext)
  const [inventory, setInventory] = useState({})
  const stripeSku = skus[id]
  const { product } = stripeSku

  const updateProducts = async () => {
    const { data, error } = await fetch('/.netlify/functions/getSku',
      {
        method: 'POST',
        body: JSON.stringify({
          id
        })
      })
      .then(response => response.json())
      .catch(error => console.error(error))

    if (error) {
      console.error(error)
    }
    setInventory(data.inventory)
  }

  useEffect(() => {
    updateProducts()
  }, [])



  return (
    <React.Fragment>
      <SEO
        type="product"
        title={product.name}
        description={product.description}
      // image={withPrefix(product.mainImage.childImageSharp.fluid.src)}
      />

      <div className="flex flex-wrap">
        <div className="py-2 md:py-5 md:px-5 w-full lg:w-1/2">
          <div className="sticky pin-t">
            <Photo
              src={stripeSku.product.localFiles[0]}
              alt={product.name}
              transparent
            />
          </div>
        </div>

        <div className="py-2 md:py-5 md:px-5 md:pr-10 w-full lg:w-1/2">
          <div className="my-2 flex flex-col md:flex-col-reverse">
            <h1 className="text-3xl md:text-5xl text-black font-normal">
              {product.name}
            </h1>

            <span className="block text-grey text-xl md:my-2 md:mt-8 inline-flex items-center">
              {formatPrice(stripeSku.price, stripeSku.currency, "en-in")}
              {
                (<Badge
                  color={inventory.quantity > 0 || inventory.type === "bucket" ? 'green' : 'red'}
                  className="mx-2"
                >
                  {(inventory.quantity || inventory.type === "bucket")
                    ? (inventory.type === "finite")
                      ? `${inventory.quantity} in stock `
                      : 'In Stock'
                    : 'Out of stock'}
                </Badge>
                )}
            </span>
          </div>

          {(
            <div className="flex flex-wrap flex-col md:flex-row md:items-end">
              <AddToCart skuId={stripeSku.id} max={(inventory.type === "finite" && inventory.quantity < 11) ? inventory.quantity : 10} disabled={(inventory.quantity === 0) && inventory.type === "finite" ? true : false} />
            </div>
          )}

          <div className="my-2 md:my-5">
            <h4 className="hidden md:block text-lg text-black font-bold my-2">
              Description
            </h4>
            <p>{product.description}</p>

            <SocialLinks product={product} />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
export default ProductPage
